import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { PATHS } from "./routes/paths";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import QuemSomos from "./pages/QuemSomos";
import Metodologia from "./pages/Metodologia";
import OndeEstamos from "./pages/OndeEstamos";
import RegionalHub from "./pages/RegionalHub";
import ParaEmpresas from "./pages/ParaEmpresas";
import Blog from "./pages/Blog";
import Post from "./pages/Post";
import Transparencia from "./pages/Transparencia";
import TransparenciaFile from "./pages/TransparenciaFile";
import Contato from "./pages/Contato";
import Apoie from "./pages/Apoie";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Maintenance from "./pages/Maintenance";
import AdminCidades from "./pages/AdminCidades";
import AdminCidadeNova from "./pages/AdminCidadeNova";
import AdminCidade from "./pages/AdminCidade";
import AdminBlog from "./pages/AdminBlog";
import AdminContato from './pages/AdminContato';
import AdminHome from './pages/AdminHome';
import AdminRodape from './pages/AdminRodape';
import AdminCabecalho from './pages/AdminCabecalho';
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import MenuAdmin from "./components/HeaderAdmin/MenuAdmin";
import { Navigate } from "react-router-dom";
import api from "./services/api";

function PublicSiteGate() {
  const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get("/config/maintenance").catch(() => ({ data: { enabled: false } })),
      api.get("/auth/verify").catch(() => null),
    ]).then(([maintenanceResponse, authResponse]) => {
      setMaintenanceEnabled(maintenanceResponse.data?.enabled === true);
      setIsAuthenticated(Boolean(authResponse));
      setIsChecking(false);
    });
  }, []);

  if (isChecking) return null;
  return maintenanceEnabled && !isAuthenticated ? <Maintenance /> : <Outlet />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicSiteGate />}>
          <Route element={<MainLayout />}>
          <Route path={PATHS.home} element={<Home />} />
          <Route path={PATHS.quemSomos} element={<QuemSomos />} />
          <Route path={PATHS.metodologia} element={<Metodologia />} />
          <Route path={PATHS.ondeEstamos} element={<OndeEstamos />} />
          <Route path={`${PATHS.ondeEstamos}/:slug`} element={<RegionalHub />} />
          <Route path={PATHS.paraEmpresas} element={<ParaEmpresas />} />
          <Route path={PATHS.blog} element={<Blog />} />
          <Route path={`${PATHS.blog}/:idOrSlug`} element={<Post />} />
          <Route path={PATHS.transparencia} element={<Transparencia />} />
          <Route path={PATHS.contato} element={<Contato />} />
          <Route path={PATHS.apoie} element={<Apoie />} />
          <Route path="*" element={<NotFound />} />
          </Route>
        </Route>

        <Route path={PATHS.login} element={<Login />} />
        <Route path={PATHS.forgotPassword} element={<ForgotPassword />} />
        <Route path={PATHS.resetPassword} element={<ResetPassword />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<MenuAdmin />}>
            <Route path={PATHS.admin} element={<Navigate to={PATHS.adminHome} replace />} />
            <Route path={PATHS.adminCidades} element={<AdminCidades />} />
            <Route path={PATHS.adminCidadeNova} element={<AdminCidadeNova />} />
            <Route path={PATHS.adminCidade} element={<AdminCidade />} />
            <Route path={PATHS.adminBlog} element={<AdminBlog />} />
            <Route path={PATHS.adminContato} element={<AdminContato />} />
            <Route path={PATHS.adminHome} element={<AdminHome />} />
            <Route path={PATHS.adminRodape} element={<AdminRodape />} />
            <Route path={PATHS.adminCabecalho} element={<AdminCabecalho />} />
            <Route path={PATHS.adminMetodologia} element={<Metodologia />} />
            <Route path={PATHS.adminApoie} element={<Apoie />} />
            <Route path={PATHS.adminTransparencia} element={<Transparencia />} />
            <Route path={PATHS.transparenciaFile} element={<TransparenciaFile />} />
            <Route path={PATHS.adminParaEmpresas} element={<ParaEmpresas />} />            
            <Route path={PATHS.adminQuemSomos} element={<QuemSomos />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
